import { Tag, Strategy } from "@phosphor-icons/react";
import * as React from "react";
import { Dropdown } from "../Dropdown";
import styles from "../Navbar.module.css";

export interface AgentsDropdownContentProps {
  isSwitching?: boolean;
  isExiting?: boolean;
}

// Pricing Agent icon - tag for pricing/tagging products
const PricingAgentIcon = () => (
  <div className={`${styles.productIcon} ${styles.pricingAgentIcon}`}>
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Tag size={19} weight="fill" />
    </div>
  </div>
);

// Negotiation Agent icon - strategy for planning
const NegotiationAgentIcon = () => (
  <div className={`${styles.productIcon} ${styles.negotiationAgentIcon}`}>
    <Strategy size={19} weight="fill" />
  </div>
);

export const AgentsDropdownContent: React.FC<AgentsDropdownContentProps> = ({
  isSwitching,
  isExiting,
}) => (
  <Dropdown
    width="wide"
    isSwitching={isSwitching}
    isExiting={isExiting}
    sections={[
      {
        title: "AGENTS",
        layout: "row",
        items: [
          {
            icon: <PricingAgentIcon />,
            title: "Pricing Agent",
            badge: "New",
            description:
              "Get real-time pricing benchmarks and contract reviews to make smarter purchasing decisions",
            href: "/products/pricing-agent",
          },
          {
            icon: <NegotiationAgentIcon />,
            title: "Negotiation Agent",
            badge: "New",
            description:
              "Get personalized insights and autonomous negotiations from Vendr's expert team",
            href: "/products/negotiating-agent",
          },
        ],
      },
    ]}
  />
);
